<a *ngIf="isLoggedIn && currentEspaceClient && showDocNav" id="header-navLink-document" class="header-navLink header-navLink--documents hide-mobile" (click)="loadEspaceDoc(); toggleDocuments.emit()">
    <span>{{ 'header.link.documents' | i18n }}</span>
</a>
<a id="header-navLink-document-mobile" *ngIf="isLoggedIn && currentEspaceClient" class="header-navLink header-navLink--documents hide show-mobile" (click)="loadEspaceDoc(); toggleMobileRightMenu()">
    <span class="header-navItem__text-mobile">{{ 'header.link.documentsMobile' | i18n }}</span>
</a>

<div
    class="cand-modal cand-modal--side-mobile documentary-space documentary-space--mobileContainer hide show-mobile"
    [ngClass]="{
        'documentary-space--mobileContainer--opened': espaceDocVisibility
    }"
>
    <article class="cand-modal__overlay">
        <div [hidden]="selectedItem" class="documentary-space__home">
            <h1 class="cand-modal__title">{{ 'documents.title' | i18n }}</h1>
            <section class="cand-modal__content">
                <div class="documentary-space__introduction" [innerHTML]="'documents.introduction' | i18n"></div>
                <h2 class="page-subtitle page-subtitle--primary page-subtitle--uppercase page-subtitle--centered page-subtitle--no-padding">
                    {{ 'documents.mobile.select' | i18n }}
                </h2>
                <nav>
                    <ul class="pills pills--link">
                        <li *ngFor="let itemContextDossier of contextDossierArray" (click)="loadEspaceDocByIdDossierMobile(itemContextDossier)" class="pill">
                            <div class="pill__header pill__header--link">
                                <span class="pill__header__title"> Dossier n°{{ itemContextDossier.emprunteur.idSousDossier.toString() }}</span>
                                <span class="pill__header__subtitle">
                                    {{ 'global.insurance.productCode.' + itemContextDossier.emprunteur.assurance.offreSelectionnee.codeProduit | i18n }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </nav>
            </section>
        </div>
        <app-espace-doc-mobile *ngIf="selectedItem && allDocuments" [allEspaceDoc]="allDocuments" [currentContextDossier]="selectedContextDossier" (backToSelectionPage)="resetSelection($event)"></app-espace-doc-mobile>
    </article>
</div>

<div *ngIf="espaceDocVisibility" class="cand-modal documentary-space cand-modal--documentary hide-mobile">
    <article class="cand-modal__overlay" *ngIf="espaceDocVisibility" [@slideInOut]>
        <h1 class="cand-modal__title">{{ 'documents.title' | i18n }}</h1>
        <section class="cand-modal__content">
            <div data-tabset="">
                <div class="tabbable">
                    <ul class="tabs">
                        <li
                            *ngFor="let itemContextDossier of contextDossierArray"
                            class="tab__header ng-scope tab__header--active"
                            [ngClass]="{
                                'tab__header--active': headerTab == itemContextDossier.dossier.idProjetCredit
                            }"
                            (click)="loadEspaceDocByIdDossier(itemContextDossier)"
                        >
                            <span class="tab__header__title">Dossier n°{{ itemContextDossier.emprunteur.idSousDossier.toString() }}</span>
                            <span class="tab__header__subtitle">
                                {{ 'global.insurance.productCode.' + itemContextDossier.emprunteur.assurance.offreSelectionnee.codeProduit | i18n }}
                            </span>
                        </li>
                    </ul>
                    <div class="tab__content">
                        <div>
                            <div>
                                <div class="documentary-space__introduction" [innerHTML]="'documents.introduction' | i18n"></div>

                                <div class="simulation__group simulation__group--bottom">
                                    <div class="simulation__content">
                                        <div data-tabset="" data-tabs-inline="true" data-bordered="true" data-no-padding="true">
                                            <div class="tabbable">
                                                <ul class="tabs tabs--bordered">
                                                    <li
                                                        *ngFor="let docType of docTypes"
                                                        class="tab__header tab__header--active tab__header--inline tab__header--no-padding"
                                                        [ngClass]="{
                                                            'tab__header--active': page == docType
                                                        }"
                                                        (click)="switchToOtherTab(docType)"
                                                    >
                                                        <span class="tab__header__title">{{ 'documents.types.' + docType | i18n }}</span>
                                                    </li>
                                                </ul>
                                                <div class="tab__content">
                                                    <app-espace-doc-list-desktop *ngIf="allDocuments" [currentPage]="page" [allEspaceDoc]="allDocuments"> </app-espace-doc-list-desktop>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button type="button" class="button button--save centered" data-tag-commander="" [appTagCommander]="'tagCo.documents.previous.button'" (click)="espaceDocVisibility = !espaceDocVisibility; toggleDocuments.emit()">
                            {{ 'documents.button.prev' | i18n }}
                        </button>
                    </div>
                </div>
            </div>
        </section>
        <span class="cand-modal__overlay__close circle-close-icon" data-tag-commander="" [appTagCommander]="'tagCo.documents.previous.button'" (click)="espaceDocVisibility = !espaceDocVisibility; toggleDocuments.emit()"></span>
    </article>
    <div class="cand-modal__fade"></div>
</div>
